import { render, staticRenderFns } from "./ServiceProviders.vue?vue&type=template&id=02050b1e&scoped=true&"
import script from "./ServiceProviders.vue?vue&type=script&lang=js&"
export * from "./ServiceProviders.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProviders.vue?vue&type=style&index=0&id=02050b1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02050b1e",
  null
  
)

export default component.exports